import * as React from 'react';
import { FieldHubModal as FieldHubModalComponent } from '../../components/modals/fieldHubModal';
import { getReportEmbedToken } from '../../actions/thunkActions';
let { connect } = require('react-redux');
export const mapStateToProps = (state, ownProps)=>{
    return ownProps;
};
export const mapDispatchToProps = (dispatch, ownProps)=>{
    return {
        getReportEmbedToken: (reportData)=>dispatch(getReportEmbedToken(reportData))
    };
};
export const FieldHubModal = connect(mapStateToProps, mapDispatchToProps)(FieldHubModalComponent);
